import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { CARGO_ROUTE } from '../../../../common/utils/constants'
import { addNotification } from '../../../../store/slices/notificationSlice'
import { v4 } from 'uuid'
import { Group, NotificationTypes } from '../../../../common/types/enums'
import { getApi } from './../../../../api/api'
import { CargoItemInterface } from '../../../../common/types/interfaces'
import { RootState } from '../../../../store/store'
import { selectCargoItem, selectCargoList } from '../../../../store/slices/cargoListSlice'
import { selectCurrentUser } from '../../../../store/slices/currentUserSlice'

export const useCargoItem = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [api] = useState(getApi())
  const [item, setItem] = useState<CargoItemInterface>()
  const itemState = useSelector((state: RootState) => selectCargoItem(state, Number(id)))
  const currentUser = useSelector(selectCurrentUser)
  const cargoList = useSelector(selectCargoList)

 

  const getItem = useCallback(async () => {
    try {
      let result: CargoItemInterface
      if (currentUser) {
        result = await api.getCargo(Number(id))
      } else {
        result = await api.getAdCargo(Number(id))
      }
      if (result) {
        setItem(result)
        window.scrollTo(0, 0)
        return
      }
      dispatch(
        addNotification({
          id: v4(),
          type: NotificationTypes.ERROR,
          text: 'Груз не найден.',
        }),
      )
      navigate(CARGO_ROUTE)
    } catch (error) {
      dispatch(
        addNotification({
          id: v4(),
          type: NotificationTypes.ERROR,
          text: 'Груз не найден.',
        }),
      )
      navigate(CARGO_ROUTE)
    }
  }, [api, dispatch, id, navigate, currentUser])

  const addView = useCallback(
    async (el: CargoItemInterface) => {
      try {
        if (currentUser && currentUser.id && el.id && el.userId !== currentUser.id) {
          await api.addView({ el_id: el.id }, Group.CARGO)
          await getItem()
        }
      } catch (error) {}
    },
    [api, currentUser, getItem],
  )

  const toggleSelected = useCallback(
    async (item: CargoItemInterface) => {
      try {
        const id = item?.selected.find((el: any) => el.user_id === currentUser?.id)?.id
        if (item && id) {
          await api.deleteSelected({ id }, Group.CARGO)
          await getItem()
        } else if (item.id) {
          await api.addSelected({ el_id: item.id }, Group.CARGO)
          await getItem()
        }
      } catch (error) {}
    },
    [api, currentUser?.id, getItem],
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    // if (itemState) {
    //   setItem(itemState)
    //   return
    // }
    getItem()
  }, [api, itemState])

  useEffect(() => {
    if (itemState) addView(itemState)
  }, [itemState])

  useEffect(() => {
    if (item?.id && !cargoList.data.find((el) => el.id === item?.id)) navigate(-1)
  }, [cargoList, item?.id])

  return { item, toggleSelected }
}
